<template>
  <div class="error-page">
    <img :src="loadingImage" alt="test-data" />
  </div>
</template>

<script>
// import { Trans } from "@/plugins/translation.js";
import { mapGetters } from 'vuex';
import LoadingGif from '@/assets/image/loading.gif';
export default {
  name: 'Loading',
  data: () => ({
    loadingImage: LoadingGif
  }),
  components: {},

  computed: {
    ...mapGetters({
      status: 'getStatusCheckEvent'
    })
  }
};
</script>
<style lang="scss">
.error-page {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
